import { InjectionToken } from '@angular/core';
import { AnalyticsProvider } from './analytics-provider.interface';

/**
 * Multi-provider token. Register each analytics provider against this in
 * app.config.ts with `multi: true`; AnalyticsService receives them all.
 */
export const ANALYTICS_PROVIDERS = new InjectionToken<AnalyticsProvider[]>(
  'ANALYTICS_PROVIDERS',
);
